import React,{Component} from 'react';
import TextField from "@material-ui/core/TextField";
import { Link } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import SimpleReactValidator from "simple-react-validator";
import Api from "../../../libraries/api";
import Default from "../../../images/default.jpeg";
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {toast, ToastContainer} from "react-toastify";
import {history} from "../../../shared/configure-store";
import AuthHelper from "../../../libraries/auth-helper";

require('dotenv').config();
const validator = new SimpleReactValidator();

class MenusAdd extends Component {
    constructor(props) {

        super(props);

        this.state = {
            loading: true,
            loadingButton: false,
            loadingImage: false,
            errors: {},

            types: [],
            menus: [],

            parentId: null,
            id: '',
            name: '',
            url: '',
            active: false,
            photo: Default,
            isManage: false,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {

        document.title = 'Gudangemas - Tambah Menu';

        let profile = AuthHelper.getProfile();
        if(profile['map-menu']) {
            let roles = profile['map-menu'].map(o => {
                return {
                    id: o.id,
                    name: o.menu.name,
                    isCreate: o.isCreate,
                    isManage: o.isManage,
                }
            });

            let all = roles.filter((item) => item.name === 'Menus');

            if (all.length > 0) {
                this.setState({
                    isManage: all[0] ? all[0].isManage : false
                });
            }
        }

        let params = {
            page: 0,
            size: 50,
        };

        Api.post('/menu/main/get-all', params).then(resp => {

            if(resp.data) {
                let menu = [];
                resp.data.mainMenus.map(o => {
                    if((o.parentId === 0) && o['is-active']) {
                        menu.push({
                            id: o.id,
                            name: o.name,
                        })
                    }

                });
                console.log(menu)


                this.setState({
                    menus: menu,
                    loading: false
                    }
                );
            }

        }).catch(err => {

            this.setState({
                    errors: err,
                    loading: false
                }
            );

        });


    }

    handleChange (e, prop){

        this.setState({

            [prop]: e.target.value

        })

    };

    handleDate (date, prop){

        this.setState({

            [prop]: date

        })

    };

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleSubmit = (e) => {

        e.preventDefault();

        if (!validator.allValid()) {

            this.setState({
                    errors: validator.getErrorMessages()
                }
            );

            return false;

        }

        this.setState({
                errors: {},
                loadingButton: true,
            }
        );

        let params = {
            'name': this.state.name,
            'url': this.state.url,
            'parentId': this.state.parentId,
            'is-active': this.state.active,
        };


        Api.post('/menu/main', params).then(resp => {
            if(resp.status === 200) {
                history.push('/menus');
                this.showMessage(true, 'Menu berhasil ditambah');
            }else {
                this.showMessage(false, resp.message[0]);
            }
            this.setState({
                    loadingButton: false,
                }
            );

        }).catch(err => {

            this.setState({
                    errors: err.errors,
                    loadingButton: false
                }
            );

            this.showMessage(false, 'Invalid format data');
        });

    };

    handleGo  = (link) => {

        history.push(link);
    };


    handleChecked = e => {

        this.setState({

            active: e.target.checked,

        })

    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12">
                    <h1 className="page-title">Header Menu</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/menus" >Menu</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Ubah</li>
                        </ol>
                    </nav>

                </div>
                <div className="col-12">
                    <div className="table-wrapper">
                        <div className="row align-items-center content-title">
                            <div className="col-6">
                                <h2 className='mb-0'>Header Menu</h2>
                            </div>
                        </div>
                        <h3 className='section-title'> </h3>

                        <form name="menus" id="addMenus" className="row" noValidate>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Parent Menu</label>
                                    <TextField variant="outlined"
                                               select
                                               id="parentId"
                                               name="parentId"
                                               label="Parent"
                                               onChange={(e) => this.handleChange(e, 'parentId')}
                                               value={this.state.parentId}
                                               fullWidth
                                    >
                                        {this.state.menus.map(option => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <div className='text-danger'>{this.state.errors.parentId}</div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Nama Menu</label>
                                    <TextField variant="outlined"
                                               type='text'
                                               id='name'
                                               name="name"
                                               label="Nama Menu"
                                               onChange={(e) => this.handleChange(e, 'name')}
                                               value={this.state.name}
                                               fullWidth
                                    />
                                    {validator.message('name', this.state.name, 'required')}
                                    <div className='text-danger'>{this.state.errors.name}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Link URL</label>
                                    <TextField variant="outlined"
                                               type='text'
                                               id='url'
                                               name="url"
                                               label="Link"
                                               onChange={(e) => this.handleChange(e, 'url')}
                                               value={this.state.url}
                                               fullWidth
                                    />
                                    {validator.message('url', this.state.url, 'required')}
                                    <div className='text-danger'>{this.state.errors.url}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Status</label>
                                    <FormGroup className='mb-3 label-tnc'>
                                        <FormControlLabel
                                            color="primary"
                                            name='active'
                                            control={<Checkbox
                                                checked={this.state.active}
                                                onChange={this.handleChecked}
                                                name='active'
                                                value={true}
                                            />}
                                            label='Active'
                                            className="mb-0"
                                        />
                                    </FormGroup>
                                    <div className='text-danger'>{this.state.errors.active}</div>
                                </div>
                            </div>

                            <div className="col-12 text-center">
                                <Button
                                    className="mr-3"
                                    variant="contained"
                                    onClick={() => this.handleGo('/menus')}
                                >
                                    Batal
                                </Button>
                                {this.state.isManage &&
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleSubmit}
                                    disabled={this.state.loadingButton}
                                >
                                    Tambah { this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i> }
                                </Button>
                                }


                            </div>
                        </form>
                    </div>

                </div>
                <ToastContainer />

            </div>
        )
    }
}

export default MenusAdd;
